import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface StagedTabCountProps {
  loading: boolean;
  count?: number;
  selected?: boolean;
}

/** Queue-tab numeral, or a pulsing placeholder until `/staged-products/stats` returns. */
export default function StagedTabCount({ loading, count, selected = false }: StagedTabCountProps) {
  if (loading) {
    return (
      <Skeleton
        variant="rounded"
        animation="wave"
        width={28}
        height={14}
        aria-hidden
        data-testid="staged-tab-count-skeleton"
      />
    );
  }
  if (count == null) return null;
  return (
    <Box
      component="span"
      sx={{
        fontSize: '0.75rem',
        fontVariantNumeric: 'tabular-nums',
        color: selected ? 'primary.main' : 'text.disabled',
      }}
    >
      {count}
    </Box>
  );
}
